import { Link } from 'react-router-dom';

interface GridCard {
  id: number;
  image: string;
  tag: string;
  title: string;
  description: string;
  link: string;
  dark?: boolean;
}

interface GridCardsSectionProps {
  cards: GridCard[];
}

export default function GridCardsSection({ cards }: GridCardsSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 md:mb-14 gap-4">
          <div className="max-w-lg">
            <p className="text-foreground-400 text-sm font-semibold uppercase tracking-wide mb-2">热门推荐</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 italic">
              探索 <span className="not-italic text-accent-500">NOPAY</span> 精彩世界
            </h2>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-md lg:text-right">
            从世界杯限定产品到VIP专属服务，NOPAY钱包为您提供全方位的数字化娱乐体验，满足不同用户的需求。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <Link
              key={card.id}
              to={card.link}
              className={`group rounded-lg overflow-hidden transition-all cursor-pointer ${
                card.dark ? 'bg-foreground-900' : 'bg-background-100'
              }`}
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                {card.dark ? (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 rounded-full bg-accent-500/20 flex items-center justify-center">
                      <i className="ri-shield-check-line text-accent-400 text-3xl"></i>
                    </div>
                  </div>
                ) : (
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                )}
              </div>
              <div className="p-5 md:p-6">
                <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full mb-3 whitespace-nowrap ${
                  card.dark
                    ? 'bg-accent-500/20 text-accent-400'
                    : 'bg-accent-100 text-accent-700'
                }`}>
                  {card.tag}
                </span>
                <h3 className={`font-heading text-lg font-bold mb-2 leading-snug ${
                  card.dark ? 'text-white' : 'text-foreground-900'
                }`}>
                  {card.title}
                </h3>
                <p className={`text-sm leading-relaxed ${
                  card.dark ? 'text-foreground-300' : 'text-foreground-600'
                }`}>
                  {card.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}